<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1-2">
<p class="centerImage"><img alt="image" src="images/img8.jpg" style="max-width: 100%"/></p>
<p class="caption"><em class="italic">The general who conquered the Isle of Wight – the future emperor Vespasian, from a marble bust</em>. <span class="smallcaps">The author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_ch12.vue?1fd6e582